import { Injectable} from '@angular/core';
import download from 'downloadjs';

@Injectable()
export class DownloadFileService {

  downloadFile(fileURL: string, fileName: string, fileType = 'application/pdf'): void {
    const x = new XMLHttpRequest();

    x.open( 'GET', fileURL , true);
    x.responseType = 'blob';
    x.onload = (e: any) => {
      download(e.target.response, fileName, fileType);
    };

    x.send();
  }
}
